/* eslint-disable */
import axios from 'axios';

const ls = require('local-storage')

const monCompteUrl = (endpoint) => `${process.env.VUE_APP_MON_COMPTE_MB_BACKEND_URL}/${endpoint}`;

export default {
  async getUserToken() {
    return ls.get('userToken');
  },
  async loginWithCredentials(email, password) {
    const { data } = await axios.post(
      monCompteUrl('authenticateSuperAdminUser'),
      { email, password });
    if (!data || !data.userToken) {
      throw new Error('authenticationFailed');
    }
    return data;
  },
  async logout() {
    return Promise.resolve(true);
  },
};
